(() => {
  const dialog = document.querySelector('dialog');
  let opener;
  document.querySelectorAll('[data-photo]').forEach(button => button.addEventListener('click', () => {
    opener=button;
    let img=dialog.querySelector('img');
    if(!img){img=document.createElement('img');dialog.insertBefore(img,dialog.querySelector('p'));}
    img.src=button.dataset.photo;img.alt=button.dataset.photoAlt;
    dialog.querySelector('p').textContent=button.dataset.photoCaption;
    dialog.showModal();
  }));
  dialog.querySelector('button').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  dialog.addEventListener('close',()=>opener?.focus());
  const rail=document.querySelector('[data-gallery-rail]');
  const playButton=document.querySelector('[data-gallery-autoplay]');
  const preference=matchMedia('(prefers-reduced-motion: reduce)');
  let playing=!preference.matches;
  function setPlaying(value){playing=value;playButton.textContent=value?'Pause':'Play';playButton.setAttribute('aria-label',value?'Pause slideshow':'Play slideshow');playButton.setAttribute('aria-pressed',String(!value));}
  setPlaying(playing);
  playButton.addEventListener('click',()=>setPlaying(!playing));
  rail.addEventListener('pointerdown',()=>setPlaying(false));
  rail.addEventListener('focusin',()=>setPlaying(false));
  preference.addEventListener('change',()=>{if(preference.matches)setPlaying(false);});
  setInterval(()=>{
    if(!playing||document.hidden||dialog.open||rail.matches(':hover')||rail.contains(document.activeElement))return;
    const rect=rail.getBoundingClientRect();if(rect.bottom<=0||rect.top>=innerHeight)return;
    const step=rail.firstElementChild.getBoundingClientRect().width+16;
    const end=rail.scrollWidth-rail.clientWidth;
    rail.scrollTo({left:rail.scrollLeft>=end-4?0:Math.min(end,rail.scrollLeft+step),behavior:preference.matches?'auto':'smooth'});
  },4000);
  document.querySelectorAll('[data-gallery-direction]').forEach(button=>button.addEventListener('click',()=>{setPlaying(false);rail.scrollBy({left:Number(button.dataset.galleryDirection)*rail.clientWidth*.8,behavior:preference.matches?'auto':'smooth'});}));
  document.querySelectorAll('[data-translation]').forEach(button=>button.addEventListener('click',()=>{
    const value=button.dataset.translation;
    document.querySelectorAll('[data-translation]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
    document.querySelectorAll('[data-product-translation]').forEach(item=>item.hidden=value!=='All'&&item.dataset.productTranslation!==value);
  }));
  const incoming=new URLSearchParams(location.search);
  document.querySelectorAll('a[data-cta]').forEach(link=>{
    const destination=new URL(link.href);
    for(const key of ['utm_source','utm_medium','utm_campaign','utm_term','fbclid']){const value=incoming.get(key);if(value)destination.searchParams.set(key,value);}
    destination.searchParams.set('utm_content',[incoming.get('utm_content'),link.dataset.cta].filter(Boolean).join('_'));
    link.href=destination.toString();
  });
})();
